import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTicketFilled = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={32}
    fill="none"
    viewBox="0 0 40 32"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-ticket-filled_svg__a)">
      <path
        fill="#fff"
        fillOpacity={0.95}
        d="M13.75 17.75v-7.5h12.5v7.5h-12.5Zm17.5-5.625c-1.055 0-1.875.86-1.875 1.875 0 1.055.82 1.875 1.875 1.875v3.75c0 1.055-.86 1.875-1.875 1.875h-18.75a1.851 1.851 0 0 1-1.875-1.875v-3.75c1.016 0 1.875-.938 1.875-1.914 0-1.016-.86-1.836-1.875-1.836v-3.75c0-1.016.82-1.875 1.875-1.875h18.75c1.016 0 1.875.86 1.875 1.875v3.75Zm-3.75 5.938V9.938A.95.95 0 0 0 26.562 9H13.438a.925.925 0 0 0-.937.938v8.124c0 .547.39.938.938.938h13.124c.508 0 .938-.39.938-.938Z"
      />
    </g>
    <defs>
      <filter
        id="icon-ticket-filled_svg__a"
        width={38.5}
        height={36}
        x={0.75}
        y={-2}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_19669"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_19669"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_19669"
          result="effect2_dropShadow_9632_19669"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_19669"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconTicketFilled;
